import { Helmet } from 'react-helmet-async';
import getCanonicalUrl from '../utils/canonical';

const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>Privacy Policy | Officine del Cuore</title>
        <meta name="description" content="Informativa sulla privacy di Officine del Cuore. Scopri come proteggiamo i tuoi dati personali con massima riservatezza e sicurezza." />
        <link rel="canonical" href={getCanonicalUrl('privacy-policy')} />
      </Helmet>

      <section className="section-elegant">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-4xl font-playfair font-bold text-burgundy mb-8 text-center">
            Informativa sulla Privacy
          </h1>

          <div className="prose-elegant space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">1. Titolare del Trattamento</h3>
              <p>
                Il titolare del trattamento è Officine del Cuore - p. iva 07950151212 - CCIAA Napoli n. REA NA- 927026, con sede a Napoli in Via G. Testa, 16. Email: info@officinedelcuore.it
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">2. Dati Raccolti</h3>
              <p className="mb-3">
                Per l'erogazione dei nostri servizi di agenzia matrimoniale, raccogliamo e trattiamo le seguenti categorie di dati personali:
              </p>
              <p className="mb-2">
                <strong>Dati anagrafici e di contatto:</strong> nome, cognome, data di nascita, indirizzo email, numero di telefono, indirizzo di residenza.
              </p>
              <p className="mb-2">
                <strong>Dati di profilazione personale:</strong> stato civile, professione, interessi, preferenze personali e caratteristiche fisiche, necessari per la ricerca di profili compatibili.
              </p>
              <p className="mb-3">
                <strong>Dati di navigazione:</strong> indirizzi IP, tipo di browser, pagine visitate sul nostro sito web.
              </p>
              <p>
                <strong>Nota:</strong> Il trattamento di dati particolari (es. orientamento religioso o politico) avviene esclusivamente previo consenso esplicito dell'interessato e solo se strettamente necessario per le finalità del servizio.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">3. Finalità del Trattamento</h3>
              <p className="mb-3">
                I Suoi dati personali sono trattati per le seguenti finalità:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Erogazione del servizio di agenzia matrimoniale e ricerca di profili compatibili.</li>
                <li>Gestione delle richieste di contatto e di informazioni inoltrate tramite il sito web.</li>
                <li>Adempimento di obblighi fiscali, contabili e di legge.</li>
                <li>Invio di comunicazioni di servizio relative al Suo abbonamento o profilo.</li>
                <li>Previo Suo consenso esplicito, invio di materiale promozionale o newsletter (marketing).</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">4. Base Giuridica del Trattamento</h3>
              <p className="mb-3">
                Il trattamento dei Suoi dati si fonda sulle seguenti basi giuridiche (art. 6 GDPR):
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Esecuzione di un contratto:</strong> per i dati necessari all'erogazione del servizio richiesto.</li>
                <li><strong>Obbligo legale:</strong> per i dati necessari agli adempimenti fiscali e normativi.</li>
                <li><strong>Consenso:</strong> per il trattamento di dati particolari e per finalità di marketing.</li>
                <li><strong>Legittimo interesse:</strong> per la sicurezza del sito web e la prevenzione di frodi.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">5. Utilizzo dei Cookie</h3>
              <p className="mb-3">
                Il nostro sito web utilizza cookie tecnici strettamente necessari per il funzionamento della piattaforma e cookie analitici (in forma anonimizzata) per comprendere come gli utenti interagiscono con il sito.
              </p>
              <p>
                Non utilizziamo cookie di profilazione di terze parti senza il Suo preventivo consenso. Può gestire le Sue preferenze sui cookie in qualsiasi momento tramite le impostazioni del Suo browser.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">6. Conservazione dei Dati</h3>
              <p className="mb-3">
                I dati personali saranno conservati per il tempo strettamente necessario a conseguire le finalità per cui sono stati raccolti. Nello specifico:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>I dati relativi al profilo e al servizio:</strong> per tutta la durata del contratto e per i 12 mesi successivi alla sua cessazione.</li>
                <li><strong>I dati fiscali e contabili:</strong> per 10 anni, come previsto dalla normativa vigente.</li>
                <li><strong>I dati trattati per finalità di marketing:</strong> fino alla revoca del consenso.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">7. Diritti dell'Interessato</h3>
              <p className="mb-3">
                Ai sensi degli artt. 15-22 del GDPR, Lei ha il diritto di:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Chiedere l'accesso ai propri dati personali.</li>
                <li>Richiedere la rettifica di dati inesatti o l'integrazione di quelli incompleti.</li>
                <li>Richiedere la cancellazione dei dati (diritto all'oblio) nei casi previsti dalla legge.</li>
                <li>Ottenere la limitazione del trattamento.</li>
                <li>Richiedere la portabilità dei dati.</li>
                <li>Opporsi al trattamento per motivi legittimi.</li>
                <li>Revocare il consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca.</li>
              </ul>
              <p className="mt-3">
                Per esercitare i Suoi diritti, può contattare il Titolare inviando un'email a <a href="mailto:info@officinedelcuore.it" className="text-gold hover:underline">info@officinedelcuore.it</a>.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-burgundy mb-3">8. Modifiche alla Privacy Policy</h3>
              <p>
                Il Titolare si riserva il diritto di apportare modifiche alla presente Privacy Policy in qualunque momento, dandone informazione agli utenti su questa pagina. La preghiamo dunque di consultare regolarmente questa pagina, facendo riferimento alla data di ultima modifica indicata in alto.
              </p>
            </div>

            <div className="bg-warm-white p-6 rounded-lg border-l-4 border-gold mt-8">
              <p className="text-sm text-burgundy font-semibold mb-0">
                Ultimo aggiornamento: 31 Marzo 2026
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
